
export default {
  SET_NEXT_SEQ_CODE: (state, payload) => state.nextSeqCode = payload,

  SET_TRENCHERS: (state, payload) => state.trenchers = payload,
}